export default {
    title: 'Places',
    count: '{n} place | {n} places',
    noList: 'No list',
    dragToReorder: 'Drag to reorder',
    saved: 'Saved.',
    saveFailed: 'Couldn’t save.',
    removeFailed: 'Couldn’t delete.',
    orderFailed: 'Couldn’t save the order.',
    navigate: 'Navigate',
    edit: 'Edit',
    colors: {
        red: 'Red',
        orange: 'Orange',
        amber: 'Amber',
        green: 'Green',
        teal: 'Teal',
        blue: 'Blue',
        indigo: 'Indigo',
        purple: 'Purple',
        pink: 'Pink',
        gray: 'Grey',
    },
    location: {
        unsupported: 'This browser doesn’t provide location.',
        denied: 'No permission to use your location — allow it for this site in your browser.',
        failed: 'Couldn’t determine your location.',
    },
    map: {
        filters: {
            all: 'All',
            favorite: 'Favourites',
        },
        savedFlash: 'Saved: “{name}”.',
        deletedFlash: 'Deleted: “{name}”.',
        pinnedLimit: 'You can pin at most {max} — unpin one first.',
        pinnedFlash: '“{name}” pinned.',
        unpinnedFlash: '“{name}” unpinned.',
        linkFailed: 'Couldn’t read a place from this link. Paste a link from “Share” in Google Maps.',
        pasteHint: 'Copy a link from “Share” in Google Maps and paste it into the search box.',
        addFirst: 'Add a place first — then you can pin it.',
        pinHighlightTitle: 'Pin',
        pinHighlightText: 'The pin next to a place pins it to the top of the module — one tap and navigation starts.',
        pinned: 'PINNED',
        pinnedEmpty: 'Pin the places you go to most often — they’ll show up here with one-tap navigation.',
        searchPlaceholder: 'Search for a place or address, or paste a Google Maps link',
        searchLabel: 'Search for a place',
        readingLink: 'Reading link…',
        addFromLink: 'Add a place from this link',
        yourPlaces: 'YOUR PLACES',
        onMap: 'ON THE MAP',
        searching: 'Searching…',
        nothingFound: 'Nothing found — try adding the city, or tap the map.',
        here: 'I’m here',
        pasteLink: 'Paste link',
        viewLabel: 'View',
        viewMap: 'Map',
        viewList: 'List',
        showMyLocation: 'Show my location',
        tapHint: 'Tap the map to save a place there — or search for it above.',
        newHereTitle: 'New place here?',
        newHereText: 'You can move the pin.',
        cancel: 'Cancel',
        add: 'Add',
        close: 'Close',
        addFavorite: 'Add to favourites',
        removeFavorite: 'Remove from favourites',
        pin: 'Pin',
        unpin: 'Unpin',
        nearestOrder: 'Nearest first — your order stays as it is',
        ownOrder: 'Your order — drag to change it',
        nearest: 'Nearest',
        noFilterMatch: 'Nothing here matches the filter.',
        noPlaces: 'You have no places yet — search for one above or tap the map.',
        navigateTo: 'Navigate to {name}',
        addFavoriteNamed: 'Add {name} to favourites',
        removeFavoriteNamed: 'Remove {name} from favourites',
        pinNamed: 'Pin {name}',
        unpinNamed: 'Unpin {name}',
        showOnMapNamed: 'Show {name} on the map',
    },
    lists: {
        title: 'Place lists',
        count: '{n} list | {n} lists',
        newList: 'New list',
        addList: '+ New list',
        heading: 'PLACE LISTS',
        removeNamed: 'Delete list {name}',
        empty: 'Group your places, e.g. “Food”, “Car”, “Family” — each list has its own pin colour on the map.',
        withoutList: 'No list: {n} place. | No list: {n} places.',
        dialogEdit: 'Place list',
        dialogNew: 'New place list',
        removed: 'List deleted — its places now have no list.',
        removeMessage: 'The places on this list will stay — they’ll move to “No list”.',
        fields: {
            name: 'Name',
            namePlaceholder: 'e.g. Food',
            color: 'Pin colour',
        },
    },
    settings: {
        title: 'Places settings',
        startView: 'START VIEW',
        startViewLabel: 'Start view',
        mapHint: 'All pins at once',
        listHint: 'Your order, grouped by place list',
        mapFlash: 'Places will open on the map.',
        listFlash: 'Places will open on the list.',
        toggleNote: 'The Map/List switch in the module only changes the view for now.',
    },
    dialog: {
        titleEdit: 'Place',
        titleNew: 'New place',
        name: 'Name',
        namePlaceholder: 'e.g. Office car park',
        point: 'Point on the map',
        address: 'Address',
        addressPlaceholder: 'Filled in from the point',
        list: 'Place list',
        favorite: 'Favourite',
        favoriteHint: 'I like this place',
        pinned: 'Pinned',
        pinnedHint: 'A navigation tile at the top of the module',
        pinnedFullHint: 'You already have {max} pinned — unpin one first',
        pinnedLimit: 'At most {max} pinned places.',
        note: 'Note',
        notePlaceholder: 'e.g. enter from the back yard, gate code',
        pointHint: 'Move the pin or tap the map to adjust the point.',
    },
    firstSteps: {
        place: {
            title: 'Your first place',
            action: 'Add a place',
            what: 'Save a place you keep going back to — search for it, tap the map or use “I’m here”.',
            why: 'Then you navigate there with one tap and add it to events without looking up the address.',
        },
        list: {
            title: 'Place list',
            action: 'New list',
            what: 'A group of places with a colour, e.g. “Food” or “Car”.',
            why: 'On the map the colour shows at a glance what’s what, and the filter shows a single list.',
        },
        pinned: {
            title: 'Pinned place',
            action: 'Show me how',
            what: 'Pin the place you go to most often — with the pin on the list or in the form.',
            why: 'It gets a tile at the top of the module: one-tap navigation and the first suggestion for events.',
        },
    },
    help: {
        add: {
            title: 'Adding a place',
            text: 'Search by name or address, tap the map, use “I’m here” or paste a Google Maps link. You’ll always get a form with a pin you can move.',
            more: 'Paste the link from “Share” in Google Maps together with the name — the name goes to the place and the point from the link to the map. The address fills in from the point.',
        },
        pinned: {
            title: 'Pinned',
            text: 'Places close at hand: one tap starts navigation. They’re the first suggestions when you add an event.',
            more: 'You can pin up to 6. Pin a place with the pin on the list or in its form.',
        },
        map: {
            title: 'Map and list',
            text: 'All your places — pins in the colour of their place list, favourites with a heart. The filters above the map show a single list or just favourites.',
            more: 'The Map/List switch changes the view for now; choose the one the module starts with in Settings. On the list, “Nearest” temporarily sorts by distance from you — your own order stays.',
        },
        lists: {
            title: 'Place lists',
            text: 'Groups of places with their own colour, e.g. “Food”, “Car”, “Family”. A place is on one list or has no list.',
            more: 'Drag to set the order of lists and of the places in them. Deleting a list doesn’t delete its places — they move to “No list”.',
        },
        favorites: {
            title: 'Favourites',
            text: 'A heart on a place you like. You can filter favourites, and they get a highlighted pin on the map. You can have as many as you like.',
        },
        view: {
            title: 'Start view',
            text: 'Whether Places opens on the map or on the list. The setting is saved to your account — it works the same on every device.',
        },
    },
    tour: {
        welcome: {
            title: 'Welcome to Places',
            description: 'Your places on a map: the car park by the office, your favourite pizzeria, the mechanic. Save them once, then navigate with one tap and add them to events.',
        },
        end: {
            title: 'That’s it',
            description: 'The guide is always there under the “Help” button — along with Getting started. And “What’s this?” next to each section explains it without the guide.',
        },
    },
};
